import {
    GA4FeatureCategory,
    GA4ItemListName,
    ProductType as TrackingProductType,
} from '@jsmdg/tracking';
import { PageType } from '../../shared/enums/pageType';
import { ProductType } from '../../shared/enums/productType';
import { TrackingListName } from '../enums';

export const featureCategoryMap: Partial<Record<PageType, GA4FeatureCategory>> = {
    [PageType.Product]: GA4FeatureCategory.ProductDetailInformation,
    [PageType.Wishlist]: GA4FeatureCategory.Wishlist,
    [PageType.Cart]: GA4FeatureCategory.Cart,
};

export const itemListNameMap: Partial<Record<TrackingListName, GA4ItemListName>> = {
    [TrackingListName.Recommendation]: GA4ItemListName.Recommendation,
    [TrackingListName.LastSeen]: GA4ItemListName.LastSeen,
    [TrackingListName.Bestseller]: GA4ItemListName.Bestseller,
};

export const trackingProductTypeMap: Record<ProductType, TrackingProductType> = {
    [ProductType.ExperienceProduct]: TrackingProductType.Experience,
    [ProductType.BoxProduct]: TrackingProductType.Box,
    [ProductType.ValueVoucherProduct]: TrackingProductType.ValueVoucher,
};
